import styled from 'styled-components';
import { Text, AvatarImage } from '@custom-components';
import { mixins, media } from '../../css';

export const CardTitle = styled(Text.HeadingFourth)`
  width: 100%;
  ${media.greaterThan('md')`width: 90%;`};
`;

export const CardDetails = styled(Text.CopyParagraph)`
  margin: 0;
`;

export const ProfileContainer = styled.div`
  display: flex;
  align-items: center;
  width: 250px;
`;

export const UserInfo = styled.div`
  flex-grow: 1;
  padding-left: 5px;
`;

export const ProfilePic = styled.div`
  width: ${mixins.pxToRem(60)};
  height: ${mixins.pxToRem(60)};
  margin: ${mixins.pxToRem(10)} auto;
  ${media.lessThan('lg')`margin-left: 0`};
  flex-grow: 0;
`;

export const AutoAvatar = styled(AvatarImage)`
  width: 60px;
  height: 60px;
`;
